import { Component, HostBinding } from '@angular/core';
import { translationKeys } from '../../../sharedTranslationKeys';
import { AvanoTableFilteringService } from '../avano-table-filtering.service';

@Component({
  selector: 'th[avanoTableFiltersReset]',
  template: `<button (click)="onFilterResetClicked()" class="icon-content-filter-remove" title="{{ buttonLabelTranslationKey | translate }}"></button>`,
  styleUrls: ['./table-filters-reset-component.scss'],
})
export class TableFiltersResetComponent {
  buttonLabelTranslationKey = translationKeys.AvanoTable.TableHeader.ResetAllFilters
  @HostBinding('class') width = "avano-table-header-filterreset-placeholder"
  
  constructor(private filteringService: AvanoTableFilteringService) {}  

  onFilterResetClicked(): void {
    this.filteringService.resetAllFilters()
  }
}
